/*
 * Abo-Box (Redesign)
 * ------------------
 * Steuert die Karten "Spar-Abo" / "Einmalig" und hält die Preise aktuell.
 * Das eigentliche Abo-Feld (selling_plan) verwaltet weiterhin <product-subscription>
 * aus custom.js – hier wird nur der versteckte Schalter [js-subcription-selection] gesetzt.
 *
 * Aktiv, wenn data-mode="always" ODER <html> die Klasse "abo-v2" trägt (ABlyft-Variante).
 *
 * Staffelpreise (stf): Abo gibt es nur für die Einzelpackung.
 *  - Klick auf Spar-Abo bei 2x/3x → springt auf die 1er-Stufe
 *  - Wechsel auf 2x/3x bei aktivem Abo → stellt auf Einmalig um
 */
(function () {
  if (customElements.get('abo-box')) return;

  var VARIANT_EVENTS = ['product:variant-change', 'variant:changed', 'variantChange'];

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  class AboBox extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this._active = false;

      try {
        var raw = this.querySelector('[data-abo-prices]');
        this._prices = raw ? JSON.parse(raw.textContent) : {};
      } catch (e) {
        this._prices = {};
      }
      this._pct = parseFloat(this.dataset.pct) || 0;
      this._form = document.getElementById(this.dataset.formId);
      this._toggle = this.querySelector('[js-subcription-selection]');
      this._modes = this.querySelectorAll('[data-abo-mode]');
      this._priceAbo = this.querySelector('[data-abo-price="abo"]');
      this._priceOnce = this.querySelector('[data-abo-price="once"]');

      var self = this;
      this._modes.forEach(function (btn) {
        btn.addEventListener('click', function () { self.select(btn.dataset.aboMode, true); });
        btn.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var next = btn.dataset.aboMode === 'abo' ? 'once' : 'abo';
          self.select(next, true);
          var target = self.querySelector('[data-abo-mode="' + next + '"]');
          if (target) target.focus();
        });
      });

      // abo-visibility.js kann den Schalter ausschalten (Variante ohne Abo) → UI nachziehen
      this._toggle.addEventListener('change', function () { self._paint(); });

      this._refresh = function () {
        self.updatePrices();
        self._syncTier();
      };
      VARIANT_EVENTS.forEach(function (n) { document.addEventListener(n, self._refresh); });
      document.addEventListener('stf:render', this._refresh);
      var scope = this.closest('.shopify-section') || document;
      scope.addEventListener('change', function () { setTimeout(self._refresh, 60); });

      this._checkActive();
      if (this.dataset.mode !== 'always' && !this._active) {
        // ABlyft setzt die Klasse evtl. erst nach dem Rendern
        this._mo = new MutationObserver(function () { self._checkActive(); });
        this._mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      }
    }

    disconnectedCallback() {
      var self = this;
      VARIANT_EVENTS.forEach(function (n) { document.removeEventListener(n, self._refresh); });
      document.removeEventListener('stf:render', this._refresh);
      if (this._mo) this._mo.disconnect();
      this._init = false;
    }

    _checkActive() {
      var on = this.dataset.mode === 'always' || document.documentElement.classList.contains('abo-v2');
      if (on && !this._active) {
        this._active = true;
        if (this._mo) { this._mo.disconnect(); this._mo = null; }
        this._deactivateLegacy();
        this._applyDefault(0);
      }
    }

    // Alter Abo-Block (falls im A/B-Modus mitgerendert) darf kein selling_plan mitsenden
    _deactivateLegacy() {
      var area = this.closest('.add-to-cart-area') || document;
      var self = this;
      area.querySelectorAll('[js-subcription-selection]').forEach(function (t) {
        if (self.contains(t)) return;
        if (t.checked) { t.checked = false; t.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }

    _applyDefault(tries) {
      var self = this;
      var root = this._stfRoot();
      // Staffelpreise noch nicht fertig gerendert → kurz warten
      if (!root && document.querySelector('[data-stf-root]') && tries < 30) {
        setTimeout(function () { self._applyDefault(tries + 1); }, 100);
        return;
      }
      this.select(this.dataset.default === 'once' ? 'once' : 'abo', true);
      this.updatePrices();
    }

    _stfRoot() {
      var els = document.querySelectorAll('[data-stf-root][data-stf-ready]');
      for (var i = 0; i < els.length; i++) {
        if (els[i].getClientRects().length && els[i].__stfAboTier) return els[i];
      }
      return null;
    }

    isAbo() { return !!this._toggle.checked; }

    select(mode, userAction) {
      var wantAbo = mode === 'abo';
      var root = this._stfRoot();
      if (wantAbo && root && !root.__stfAboOk()) {
        var idx = root.__stfAboTier();
        if (idx < 0) wantAbo = false;
        else if (userAction) root.__stfSetTier(idx);
      }
      if (this._toggle.checked !== wantAbo) {
        this._toggle.checked = wantAbo;
        this._toggle.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this._paint();
      this.updatePrices();
    }

    _paint() {
      var abo = this.isAbo();
      this._modes.forEach(function (btn) {
        var on = (btn.dataset.aboMode === 'abo') === abo;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
      });
    }

    // Staffel gewechselt: 2x/3x ist kein Abo → auf Einmalig
    _syncTier() {
      if (!this._active || !this.isAbo()) return;
      var root = this._stfRoot();
      if (root && !root.__stfAboOk()) this.select('once', false);
    }

    updatePrices() {
      var once = null, abo = null;
      var root = this._stfRoot();
      if (root && root.__stfAboPrice) {
        // Abo-Preis: immer die 1er-Packung (Abo gibt es nur für 1x)
        var single = root.__stfAboPrice();
        if (single != null) abo = Math.round(single * (100 - this._pct) / 100);
        // Einmalig: Preis der aktuell gewählten Staffel (1x, 2x, 3x …)
        var cv = root.__stfCurrentVariant && root.__stfCurrentVariant();
        once = cv && cv.price != null ? cv.price : single;
        if (abo == null) abo = once;
      }
      if (once == null) {
        var field = this._form && this._form.querySelector('[name="id"]');
        var id = field && field.value ? String(field.value) : null;
        var p = id && this._prices[id];
        if (p) { once = p[0]; abo = p[1]; }
      }
      if (once == null) return;
      if (this._priceOnce) this._priceOnce.textContent = money(once);
      if (this._priceAbo) this._priceAbo.textContent = money(abo);
    }
  }

  customElements.define('abo-box', AboBox);

  // ABlyft-Goal "ATC mit Abo" (atc_abo) – feuert in BEIDEN Testgruppen, sobald mit aktivem Abo
  // in den Warenkorb gelegt wird. window-capture, weil die Staffelpreis-Logik den Klick auf
  // document-capture abfängt (stopImmediatePropagation).
  if (!window.__aboAtcGoal) {
    window.__aboAtcGoal = true;
    window.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.product-form__cart-submit, button[name="add"]');
      if (!btn || btn.closest('cart-drawer, quick-add-modal, .quick-add-modal')) return;
      var fields = document.querySelectorAll('product-subscription [name="selling_plan"]');
      var abo = false;
      for (var i = 0; i < fields.length; i++) { if (!fields[i].disabled && fields[i].value) { abo = true; break; } }
      if (abo) {
        window.ablyft = window.ablyft || [];
        window.ablyft.push({ eventType: 'custom', eventName: 'atc_abo' });
      }
    }, true);
  }
})();
